<div class="section">
  <span class="bold">Full Overview</span>
  <span class="bdr-full-overview" innerHTML="{{ comparable.fullOverview ? comparable.fullOverview : 'N/A' }}"></span>
</div>
<div class="bdr-separate"></div>

<div class="row">
  <div class="col-4 section">
    <span class="bold">Company ID</span>
    <span>{{ comparable.companyId }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Type Of Company</span>
    <span>{{ comparable.comparableType }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Year of Incorporation</span>
    <span>{{ comparable?.yearIncorporated }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Status Of Company</span>
    <span>{{ comparable?.comparableStatusMV }}</span>
  </div>
</div>
<div class="bdr-separate"></div>
<div class="row">
  <div class="col-4 section">
    <span class="bold">Captured Company Name</span>
    <span>{{ comparable.companyName }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Database Address</span>
    <span>{{ comparable.address }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Phone Number</span>
    <span>{{ comparable.comparablePhone }}</span>
  </div>

  <div class="col-4 section">
    <span class="bold">Country</span>
    <span>{{ comparable.countryName }}</span>
  </div>

  <div class="col-4 section">
    <span class="bold">Website</span>
    <span
      ><a
        class="website"
        href="{{ comparable?.companyWebSite | hyperLink }}"
        rel="noopener noreferrer"
        target="_blank"
        title="{{ comparable.companyWebSite }}"
        >{{ comparable.companyWebSite }}</a
      ></span
    >
  </div>

  <div class="col-4 section" *ngIf="isOneSource">
    <span class="bold">Annual Report</span>
    <span><a [href]="getOneSourceUrl" rel="noopener noreferrer" target="_blank">Onesource</a></span>
  </div>
  <div class="col-4 section" *ngIf="isOneSource">
    <span class="bold">10K</span>
    <span><a [href]="getSecUrl" rel="noopener noreferrer" target="_blank">SEC</a></span>
  </div>
</div>
